<div
  class="notification"
  [ngClass]="{
    'notification-accent': notificationType === 'accent',
    'notification-info': notificationType === 'info',
    'notification-warning': notificationType === 'warning',
    'notification-success': notificationType === 'success',
    'notification-error': notificationType === 'error'
  }"
>

  <svg-icon-sprite
    [src]="'./assets/img/icons/sprite.svg#' + spriteItem"
    [height]="'28'"
    [width]="'28'"
    [class]="notificationType">
  </svg-icon-sprite>

  <div class="content">
    <span *ngIf="text"
      [innerHtml]="text"
      class="content__info">
    </span>
    <span *ngIf="text && url && urlText" class="content__divider"></span>
    <a *ngIf="url && urlText"
      [href]="url"
      [innerHtml]="urlText"
      target="_blank"
      class="content__link"
    ></a>

    <ng-content></ng-content>

  </div>
</div>